function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import Loader from 'react-loader-advanced';
import TranslationManager from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/translation-manager';
import { TranslationKeys } from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/const';
import TextInput from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/components/text-input';
import ApiClient from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/api/api-client';
import ConfigurationManager from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/configuration-manager';
import CheckUtils from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/utilities/check-utils';
import Logger from '../../../../../../../wdh-foundation/wdh-logger/wdh-logger';
import ModalDialog from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/components/modal-dialog';
import { loaderBackgroundStyle, loaderOpacity, spinner } from './views/Spinner';
var AccountManagementAccordion = /*#__PURE__*/function (_React$Component) {
  function AccountManagementAccordion(props) {
    var _this;
    _classCallCheck(this, AccountManagementAccordion);
    _this = _callSuper(this, AccountManagementAccordion, [props]);
    _this.translations = {
      accountManagementHeaderText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_HEADER_TEXT),
      accountManagementDescText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_DESC_TEXT),
      accountManagementCommPreference: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_COMM_PREFERENCE),
      accountManagementUpdateNowText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_UPDATE_NOW_TEXT),
      accountManagementAccountInformationText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_ACCOUNT_INFORMATION_TEXT),
      accountManagementEditText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_EDIT_TEXT),
      accountManagementAccountNameText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_ACCOUNT_NAME_TEXT),
      accountManagementAccountNoText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_ACCOUNT_NO_TEXT),
      accountManagementBillToText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_BILL_TO_TEXT),
      accountManagementShippingAddress: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_SHIPPING_ADDRESS_TEXT),
      accountManagementBusinessPhoneText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_BUSINESS_PHONE_TEXT),
      accountManagementFaxText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_FAX_TEXT),
      accountManagementBusinessEmailText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_BUSINESS_EMAIL_TEXT),
      accountManagementBusinessPhoneRequiredText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_BUSINESS_PHONE_REQUIRED_TEXT),
      accountManagementBusinessEmailRequiredText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_BUSINESS_EMAIL_REQUIRED_TEXT),
      accountManagementFinancialCommPreText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_FINANCIAL_COMM_PRE_TEXT),
      accountManagementStatementDeliveryMethodText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_STATEMENT_DELIVERY_METHOD_TEXT),
      accountManagementDoNotSendNonEditText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_DO_NOT_SEND_NON_EDIT_TEXT),
      accountManagementMailToNonEditText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_MAIL_TO_NON_EDIT_TEXT),
      accountManagementEmailNonEditText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_EMAIL_NON_EDIT_TEXT),
      accountManagementChooseDeliveryText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_CHOOSE_DELIVERY_TEXT),
      accountManagementMailOptionText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_MAIL_OPTION_TEXT),
      accountManagementEmailOptionText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_EMAIL_OPTION_TEXT),
      accountManagementDoNotSendOptionText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_DO_NOT_SEND_OPTION_TEXT),
      accountManagementSelectEmailText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_SELECT_EMAIL_TEXT),
      accountManagementChooseEmailText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_CHOOSE_EMAIL_TEXT),
      accountManagementInvoiceDeliveryMethodText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_INVOICE_DELIVERY_METHOD_TEXT),
      accountManagementValidPhoneErrorText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_VALID_PHONE_ERROR_TEXT),
      accountManagementPhoneRequireErrorText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_PHONE_REQUIRE_ERROR_TEXT),
      accountManagementValidEmailErrorText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_VALID_EMAIL_ERROR_TEXT),
      accountManagementEmailRequireErrorText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_EMAIL_REQUIRE_ERROR_TEXT),
      accountManagementChooseEmailErrorText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_CHOOSE_EMAIL_ERROR_TEXT),
      accountManagementModalText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_MODAL_TEXT),
      accountManagementNoAccountText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_NO_ACCOUNTS_FOUND_TEXT),
      mandatoryFormField: TranslationManager.getTranslation(TranslationKeys.SHARED_MANDATORYFORMFIELD)
    };
    _this.onSelectStatementChange = _this.onSelectStatementChange.bind(_this);
    _this.onSelectInvoiceChange = _this.onSelectInvoiceChange.bind(_this);
    _this.onSelectStatementEmail = _this.onSelectStatementEmail.bind(_this);
    _this.onSelectInvoiceEmail = _this.onSelectInvoiceEmail.bind(_this);
    _this.state = {
      accountList: [],
      accountEditInfo: {},
      phoneNotComplete: false,
      emailNotComplete: false,
      accountSaveModal: false,
      savingDataLoader: false,
      invoiceEmailNotPicked: false,
      statementEmailNotPicked: false,
      emailNotValidate: false,
      phoneNotValidate: false
    };
    return _this;
  }
  _inherits(AccountManagementAccordion, _React$Component);
  return _createClass(AccountManagementAccordion, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.loadAccountList();
    }
  }, {
    key: "loadAccountList",
    value: function loadAccountList() {
      var _this2 = this;
      var loginAccountData = ConfigurationManager.getTokenDetails();
      var loginAccountNo = loginAccountData.DefaultAccountId;
      ApiClient.userManagement.getAccountListData(loginAccountNo).then(function (accountList) {
        _this2.setState({
          accountList: accountList
        }, function () {
          _this2.setState(function (prevState) {
            return {
              accountList: prevState.accountList.map(function (el) {
                return _objectSpread(_objectSpread({}, el), {}, {
                  isEdit: false,
                  active: false
                });
              })
            };
          });
        });
      });
    }
  }, {
    key: "toggleActive",
    value: function toggleActive(data) {
      data.active = !data.active;
      this.setState(function (prevState) {
        return {
          accountList: prevState.accountList.map(function (el) {
            return el.accountNumber === data.accountNumber ? _objectSpread(_objectSpread({}, el), {}, {
              active: data.active
            }) : el;
          })
        };
      });
      this.setState(function (prevState) {
        return {
          accountList: prevState.accountList.map(function (el) {
            return el.accountNumber !== data.accountNumber ? _objectSpread(_objectSpread({}, el), {}, {
              active: false,
              isEdit: false
            }) : el;
          })
        };
      });
      this.toggleStatesFalse();
    }
  }, {
    key: "toggleStatesFalse",
    value: function toggleStatesFalse() {
      // on isEdit false,empty the edit object state and turn all states false
      var isEditStatus = this.state.accountList.map(function (st) {
        return st.isEdit;
      });
      var isEditChecker = isEditStatus.every(function (x) {
        return x === false;
      });
      if (isEditChecker) {
        this.setState({
          accountEditInfo: {},
          phoneNotComplete: false,
          emailNotComplete: false,
          invoiceEmailNotPicked: false,
          statementEmailNotPicked: false,
          emailNotValidate: false,
          phoneNotValidate: false
        });
      }
    }
  }, {
    key: "editUserInfo",
    value: function editUserInfo(e, data) {
      var accountEditInfo = {};
      accountEditInfo.accountNumber = data.accountNumber;
      accountEditInfo.businessPhone = this.formatPhoneNumber(data.businessPhone);
      accountEditInfo.fax = this.formatPhoneNumber(data.fax);
      accountEditInfo.businessEmail = data.businessEmail;
      accountEditInfo.statementDeliveryMethod = data.statementDeliveryMethod;
      accountEditInfo.invoiceDeliveryMethod = data.invoiceDeliveryMethod;
      accountEditInfo.selectedStatementDeliverContact = data.selectedStatementDeliverContact;
      accountEditInfo.selectedInvoiceDeliveryContact = data.selectedInvoiceDeliveryContact;
      this.setState({
        accountEditInfo: accountEditInfo,
        phoneNotComplete: false,
        emailNotComplete: false,
        invoiceEmailNotPicked: false,
        statementEmailNotPicked: false,
        emailNotValidate: false,
        phoneNotValidate: false
      });
      this.setState(function (prevState) {
        return {
          accountList: prevState.accountList.map(function (el) {
            return el.accountNumber === data.accountNumber ? _objectSpread(_objectSpread({}, el), {}, {
              isEdit: true
            }) : el;
          })
        };
      });
      if (!e) var e = window.event;
      e.cancelBubble = true;
      if (e.stopPropagation) e.stopPropagation();
    }
  }, {
    key: "updateAccountData",
    value: function updateAccountData(phone, fax, email) {
      this.setState({
        accountEditInfo: _objectSpread(_objectSpread({}, this.state.accountEditInfo), {}, {
          businessPhone: phone,
          fax: fax,
          businessEmail: email
        })
      });
      this.setState({
        phoneNotComplete: false,
        emailNotComplete: false,
        emailNotValidate: false,
        phoneNotValidate: false,
        invoiceEmailNotPicked: false,
        statementEmailNotPicked: false
      });
    }
  }, {
    key: "onSelectStatementChange",
    value: function onSelectStatementChange(event) {
      var currentTarget = Number(event.target.value);
      this.setState({
        accountEditInfo: _objectSpread(_objectSpread({}, this.state.accountEditInfo), {}, {
          statementDeliveryMethod: currentTarget,
          selectedStatementDeliverContact: ''
        }),
        statementEmailNotPicked: false
      });
    }
  }, {
    key: "onSelectStatementEmail",
    value: function onSelectStatementEmail(event) {
      var currentTarget = event.target.value;
      this.setState({
        accountEditInfo: _objectSpread(_objectSpread({}, this.state.accountEditInfo), {}, {
          selectedStatementDeliverContact: currentTarget
        })
      });
      this.setState({
        statementEmailNotPicked: false
      });
    }
  }, {
    key: "onSelectInvoiceChange",
    value: function onSelectInvoiceChange(event) {
      var currentTarget = Number(event.target.value);
      this.setState({
        accountEditInfo: _objectSpread(_objectSpread({}, this.state.accountEditInfo), {}, {
          invoiceDeliveryMethod: currentTarget,
          selectedInvoiceDeliveryContact: ''
        }),
        invoiceEmailNotPicked: false
      });
    }
  }, {
    key: "onSelectInvoiceEmail",
    value: function onSelectInvoiceEmail(event) {
      var currentTarget = event.target.value;
      this.setState({
        accountEditInfo: _objectSpread(_objectSpread({}, this.state.accountEditInfo), {}, {
          selectedInvoiceDeliveryContact: currentTarget
        })
      });
      this.setState({
        invoiceEmailNotPicked: false
      });
    }
  }, {
    key: "isValidEmailAddress",
    value: function isValidEmailAddress(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }, {
    key: "saveEditAccountInfo",
    value: function saveEditAccountInfo(e) {
      var _this3 = this;
      e.preventDefault();
      var editAccount = this.state.accountEditInfo;
      var editAccountArray = [];
      editAccountArray.push(editAccount);
      if (CheckUtils.isNullOrEmptyString(editAccount.businessPhone)) {
        this.setState({
          phoneNotComplete: true
        });
      } else if (editAccount.businessPhone.replace(/[^\d]/g, '').length < 10) {
        this.setState({
          phoneNotValidate: true
        });
      } else if (CheckUtils.isNullOrEmptyString(editAccount.businessEmail)) {
        this.setState({
          emailNotComplete: true
        });
      } else if (!this.isValidEmailAddress(editAccount.businessEmail)) {
        this.setState({
          emailNotValidate: true
        });
      } else if (editAccount.invoiceDeliveryMethod === 2 && CheckUtils.isNullOrEmptyString(editAccount.selectedInvoiceDeliveryContact)) {
        this.setState({
          invoiceEmailNotPicked: true
        });
      } else if (editAccount.statementDeliveryMethod === 2 && CheckUtils.isNullOrEmptyString(editAccount.selectedStatementDeliverContact)) {
        this.setState({
          statementEmailNotPicked: true
        });
      } else {
        this.setState({
          savingDataLoader: true
        });
        ApiClient.userManagement.updateAccountData(editAccountArray).then(function () {
          _this3.setState({
            accountSaveModal: true,
            savingDataLoader: false
          });
        }, function (error) {
          _this3.setState({
            accountSaveModal: false,
            savingDataLoader: false
          });
          Logger.error('--- ERROR ---');
          Logger.error(error);
        });
      }
    }
  }, {
    key: "closeAccountModal",
    value: function closeAccountModal() {
      this.setState({
        accountEditInfo: {},
        accountSaveModal: false
      });
      this.loadAccountList();
    }
  }, {
    key: "cancelEditAccordion",
    value: function cancelEditAccordion(data) {
      this.setState(function (prevState) {
        return {
          accountList: prevState.accountList.map(function (el) {
            return el.accountNumber === data.accountNumber ? _objectSpread(_objectSpread({}, el), {}, {
              isEdit: false
            }) : el;
          }),
          accountEditInfo: {},
          phoneNotComplete: false,
          emailNotComplete: false,
          invoiceEmailNotPicked: false,
          statementEmailNotPicked: false,
          emailNotValidate: false,
          phoneNotValidate: false
        };
      });
    }
  }, {
    key: "formatPhoneNumber",
    value: function formatPhoneNumber(phone) {
      phone = phone.replace(/[^\d]/g, '');
      if (!CheckUtils.isNullOrEmptyString(phone)) {
        return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3');
      }
      return '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var editAccountInfo = this.state.accountEditInfo;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Loader, {
        show: this.state.savingDataLoader,
        message: spinner,
        contentBlur: loaderOpacity,
        backgroundStyle: loaderBackgroundStyle
      }, this.state.accountList.map(function (data) {
        return /*#__PURE__*/React.createElement("div", {
          key: data.accountNumber,
          className: "accordion"
        }, /*#__PURE__*/React.createElement("div", {
          className: "accordion-wrapper"
        }, /*#__PURE__*/React.createElement("div", {
          id: data.accountNumber,
          className: "accordion-header ".concat(data.active ? 'active' : ''),
          onClick: function onClick(e) {
            _this4.toggleActive(data);
          },
          role: "presentation"
        }, /*#__PURE__*/React.createElement("span", {
          className: "header-section-text"
        }, /*#__PURE__*/React.createElement("b", null, data.accountNumber, ' ', data.accountName)), /*#__PURE__*/React.createElement("span", {
          className: "show-more"
        }, data.active && /*#__PURE__*/React.createElement("span", {
          className: "show-more-text ".concat(data.isEdit ? 'edit-display' : '')
        }, /*#__PURE__*/React.createElement("a", {
          onClick: function onClick(e) {
            _this4.editUserInfo(e, data);
          }
        }, _this4.translations.accountManagementEditText)))), /*#__PURE__*/React.createElement("div", {
          className: "item-content display-block ".concat(data.active ? 'active' : '')
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
          className: "acct-info"
        }, _this4.translations.accountManagementAccountInformationText)), /*#__PURE__*/React.createElement("table", {
          className: "".concat(data.isEdit ? 'isEdit-accordion' : '')
        }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
          className: "mobile-flex-tr"
        }, /*#__PURE__*/React.createElement("td", {
          className: "first-table-row"
        }, /*#__PURE__*/React.createElement("span", {
          className: "first-span"
        }, _this4.translations.accountManagementAccountNameText), /*#__PURE__*/React.createElement("span", {
          className: "second-span"
        }, data.accountName)), /*#__PURE__*/React.createElement("td", {
          className: "second-table-row mobile-acct-td"
        }, /*#__PURE__*/React.createElement("span", {
          className: "first-span"
        }, _this4.translations.accountManagementAccountNoText), /*#__PURE__*/React.createElement("span", {
          className: "second-span"
        }, data.accountNumber)), /*#__PURE__*/React.createElement("td", {
          className: "last-table-row mobile-grd-two"
        }, /*#__PURE__*/React.createElement("span", {
          className: "first-span"
        }, _this4.translations.accountManagementShippingAddress), /*#__PURE__*/React.createElement("span", {
          className: "second-span"
        }, data.shippingAddress), data.isEdit && /*#__PURE__*/React.createElement("span", {
          className: "second-span contact-us-span"
        }, "If the address needs to be changed, please", /*#__PURE__*/React.createElement("a", {
          href: "mailto: helpwithmyoticon@oticon.com"
        }, " contact us")))), !data.isEdit && /*#__PURE__*/React.createElement("tr", {
          className: "mobile-flex-tr"
        }, /*#__PURE__*/React.createElement("td", {
          className: "first-table-row"
        }, /*#__PURE__*/React.createElement("span", {
          className: "first-span"
        }, _this4.translations.accountManagementBusinessPhoneText), /*#__PURE__*/React.createElement("span", {
          className: "second-span"
        }, _this4.formatPhoneNumber(data.businessPhone))), /*#__PURE__*/React.createElement("td", {
          className: "second-table-row"
        }, /*#__PURE__*/React.createElement("span", {
          className: "first-span"
        }, _this4.translations.accountManagementFaxText), /*#__PURE__*/React.createElement("span", {
          className: "second-span"
        }, _this4.formatPhoneNumber(data.fax))), /*#__PURE__*/React.createElement("td", {
          className: "second-table-row"
        }, /*#__PURE__*/React.createElement("span", {
          className: "first-span"
        }, _this4.translations.accountManagementBusinessEmailText), /*#__PURE__*/React.createElement("span", {
          className: "second-span"
        }, data.businessEmail))), data.isEdit && /*#__PURE__*/React.createElement("tr", {
          className: "mobile-flex-tr"
        }, /*#__PURE__*/React.createElement("td", {
          className: "first-table-row"
        }, /*#__PURE__*/React.createElement("span", {
          className: "first-span"
        }, _this4.translations.accountManagementBusinessPhoneRequiredText), /*#__PURE__*/React.createElement("span", {
          className: "second-span"
        }, /*#__PURE__*/React.createElement(TextInput, {
          name: "businessPhone",
          onValueChange: function onValueChange(event) {
            _this4.updateAccountData(event.target.value, editAccountInfo.fax, editAccountInfo.businessEmail);
          },
          inputValue: editAccountInfo.businessPhone,
          hasError: _this4.state.phoneNotComplete || _this4.state.phoneNotValidate,
          showHelpText: _this4.state.phoneNotComplete,
          helpTextHTML: _this4.translations.mandatoryFormField
        }))), /*#__PURE__*/React.createElement("td", {
          className: "second-table-row-edit fax-td"
        }, /*#__PURE__*/React.createElement("span", {
          className: "first-span"
        }, _this4.translations.accountManagementFaxText), /*#__PURE__*/React.createElement("span", {
          className: "second-span"
        }, /*#__PURE__*/React.createElement(TextInput, {
          name: "fax",
          onValueChange: function onValueChange(event) {
            _this4.updateAccountData(editAccountInfo.businessPhone, event.target.value, editAccountInfo.businessEmail);
          },
          inputValue: editAccountInfo.fax
        }))), /*#__PURE__*/React.createElement("td", {
          className: "second-table-row-edit"
        }, /*#__PURE__*/React.createElement("span", {
          className: "first-span"
        }, _this4.translations.accountManagementBusinessEmailRequiredText), /*#__PURE__*/React.createElement("span", {
          className: "second-span email-span"
        }, /*#__PURE__*/React.createElement(TextInput, {
          name: "primaryBusinessEmail",
          onValueChange: function onValueChange(event) {
            _this4.updateAccountData(editAccountInfo.businessPhone, editAccountInfo.fax, event.target.value);
          },
          inputValue: editAccountInfo.businessEmail,
          hasError: _this4.state.emailNotComplete || _this4.state.emailNotValidate,
          showHelpText: _this4.state.emailNotComplete,
          helpTextHTML: _this4.translations.mandatoryFormField
        })))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
          className: "acct-info second-block"
        }, _this4.translations.accountManagementFinancialCommPreText)), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, !data.isEdit && /*#__PURE__*/React.createElement("tr", {
          className: "mobile-grd-comm"
        }, /*#__PURE__*/React.createElement("td", {
          className: "first-table-row"
        }, /*#__PURE__*/React.createElement("span", {
          className: "first-span"
        }, _this4.translations.accountManagementStatementDeliveryMethodText), data.statementDeliveryMethod === 1 && /*#__PURE__*/React.createElement("span", {
          className: "second-span"
        }, _this4.translations.accountManagementDoNotSendNonEditText), data.statementDeliveryMethod === 0 && /*#__PURE__*/React.createElement("span", {
          className: "second-span"
        }, _this4.translations.accountManagementMailToNonEditText, ' ', data.shippingAddress), data.statementDeliveryMethod === 2 && /*#__PURE__*/React.createElement("span", {
          className: "second-span"
        }, _this4.translations.accountManagementEmailNonEditText, ' ', data.statementDeliveryContacts.map(function (el) {
          return el.deliveryContactNumber === data.selectedStatementDeliverContact ? /*#__PURE__*/React.createElement("span", null, el.deliveryContactEmail) : '';
        }))), /*#__PURE__*/React.createElement("td", {
          className: "second-table-row second-block-inv"
        }, /*#__PURE__*/React.createElement("span", {
          className: "first-span"
        }, _this4.translations.accountManagementInvoiceDeliveryMethodText), data.invoiceDeliveryMethod === 1 && /*#__PURE__*/React.createElement("span", {
          className: "second-span"
        }, _this4.translations.accountManagementDoNotSendNonEditText), data.invoiceDeliveryMethod === 0 && /*#__PURE__*/React.createElement("span", {
          className: "second-span"
        }, _this4.translations.accountManagementMailToNonEditText, ' ', data.defaultBillingAddress), data.invoiceDeliveryMethod === 2 && /*#__PURE__*/React.createElement("span", {
          className: "second-span"
        }, _this4.translations.accountManagementEmailNonEditText, ' ', data.invoiceDeliveryContacts.map(function (el) {
          return el.deliveryContactNumber === data.selectedInvoiceDeliveryContact ? /*#__PURE__*/React.createElement("span", null, el.deliveryContactEmail) : '';
        })))), data.isEdit && /*#__PURE__*/React.createElement("tbody", {
          className: "desktop-only-tbody"
        }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
          className: "first-table-row second-span-edit"
        }, /*#__PURE__*/React.createElement("span", null, _this4.translations.accountManagementStatementDeliveryMethodText), /*#__PURE__*/React.createElement("span", {
          className: "second-span-edit"
        }, /*#__PURE__*/React.createElement("div", {
          className: "comm-select-div"
        }, /*#__PURE__*/React.createElement("select", {
          value: editAccountInfo.statementDeliveryMethod,
          className: "comm-select-method",
          onChange: _this4.onSelectStatementChange
        }, /*#__PURE__*/React.createElement("option", {
          value: "0"
        }, _this4.translations.accountManagementMailOptionText), /*#__PURE__*/React.createElement("option", {
          value: "2"
        }, _this4.translations.accountManagementEmailOptionText), /*#__PURE__*/React.createElement("option", {
          value: "1"
        }, _this4.translations.accountManagementDoNotSendOptionText))))), /*#__PURE__*/React.createElement("td", {
          className: "second-span-edit second-table-row"
        }, /*#__PURE__*/React.createElement("span", null, _this4.translations.accountManagementInvoiceDeliveryMethodText), /*#__PURE__*/React.createElement("span", {
          className: "second-span-edit"
        }, /*#__PURE__*/React.createElement("div", {
          className: "comm-select-div"
        }, /*#__PURE__*/React.createElement("select", {
          value: editAccountInfo.invoiceDeliveryMethod,
          className: "comm-select-method-inv",
          onChange: _this4.onSelectInvoiceChange
        }, /*#__PURE__*/React.createElement("option", {
          value: "0"
        }, _this4.translations.accountManagementMailOptionText), /*#__PURE__*/React.createElement("option", {
          value: "2"
        }, _this4.translations.accountManagementEmailOptionText), /*#__PURE__*/React.createElement("option", {
          value: "1"
        }, _this4.translations.accountManagementDoNotSendOptionText)))))), /*#__PURE__*/React.createElement("tr", null, editAccountInfo.statementDeliveryMethod === 2 && /*#__PURE__*/React.createElement("td", {
          className: "first-table-row second-span-edit"
        }, /*#__PURE__*/React.createElement("span", null, _this4.translations.accountManagementSelectEmailText), /*#__PURE__*/React.createElement("span", {
          className: "second-span-edit"
        }, /*#__PURE__*/React.createElement("div", {
          className: "comm-select-div"
        }, /*#__PURE__*/React.createElement("select", {
          value: editAccountInfo.selectedStatementDeliverContact,
          className: "comm-select",
          onChange: _this4.onSelectStatementEmail
        }, /*#__PURE__*/React.createElement("option", {
          hidden: true,
          disabled: true,
          value: ""
        }, _this4.translations.accountManagementChooseEmailText), data.statementDeliveryContacts.map(function (contactEmail) {
          return /*#__PURE__*/React.createElement("option", {
            value: contactEmail.deliveryContactNumber
          }, contactEmail.deliveryContactEmail);
        })))), _this4.state.statementEmailNotPicked && /*#__PURE__*/React.createElement("p", {
          className: "error-text-email"
        }, "*Required field")), editAccountInfo.statementDeliveryMethod !== 2 && /*#__PURE__*/React.createElement("td", {
          className: "second-span-edit second-table-row"
        }, /*#__PURE__*/React.createElement("span", null, "\xA0")), editAccountInfo.invoiceDeliveryMethod === 2 && /*#__PURE__*/React.createElement("td", {
          className: "second-span-edit second-table-row"
        }, /*#__PURE__*/React.createElement("span", null, _this4.translations.accountManagementSelectEmailText), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
          className: "comm-select-div"
        }, /*#__PURE__*/React.createElement("select", {
          value: editAccountInfo.selectedInvoiceDeliveryContact,
          className: "comm-select",
          onChange: _this4.onSelectInvoiceEmail
        }, /*#__PURE__*/React.createElement("option", {
          hidden: true,
          disabled: true,
          value: ""
        }, _this4.translations.accountManagementChooseEmailText), data.invoiceDeliveryContacts.map(function (contactEmail) {
          return /*#__PURE__*/React.createElement("option", {
            value: contactEmail.deliveryContactNumber
          }, contactEmail.deliveryContactEmail);
        })))), _this4.state.invoiceEmailNotPicked && /*#__PURE__*/React.createElement("p", {
          className: "error-text-email"
        }, "*Required field")), editAccountInfo.invoiceDeliveryMethod !== 2 && /*#__PURE__*/React.createElement("td", {
          className: "second-span-edit second-table-row"
        }, /*#__PURE__*/React.createElement("span", null, "\xA0")))), data.isEdit && /*#__PURE__*/React.createElement("tbody", {
          className: "mobile-only-tbody"
        }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("span", null, _this4.translations.accountManagementStatementDeliveryMethodText), /*#__PURE__*/React.createElement("span", {
          className: "second-span-edit"
        }, /*#__PURE__*/React.createElement("div", {
          className: "comm-select-div"
        }, /*#__PURE__*/React.createElement("select", {
          value: editAccountInfo.statementDeliveryMethod,
          className: "comm-select-method",
          onChange: _this4.onSelectStatementChange
        }, /*#__PURE__*/React.createElement("option", {
          value: "0"
        }, _this4.translations.accountManagementMailOptionText), /*#__PURE__*/React.createElement("option", {
          value: "2"
        }, _this4.translations.accountManagementEmailOptionText), /*#__PURE__*/React.createElement("option", {
          value: "1"
        }, _this4.translations.accountManagementDoNotSendOptionText))))), /*#__PURE__*/React.createElement("tr", null, editAccountInfo.statementDeliveryMethod === 2 && /*#__PURE__*/React.createElement("td", {
          className: "first-table-row second-span-edit"
        }, /*#__PURE__*/React.createElement("span", null, _this4.translations.accountManagementSelectEmailText), /*#__PURE__*/React.createElement("span", {
          className: "second-span-edit"
        }, /*#__PURE__*/React.createElement("div", {
          className: "comm-select-div"
        }, /*#__PURE__*/React.createElement("select", {
          value: editAccountInfo.selectedStatementDeliverContact,
          className: "comm-select",
          onChange: _this4.onSelectStatementEmail
        }, /*#__PURE__*/React.createElement("option", {
          hidden: true,
          disabled: true,
          value: ""
        }, _this4.translations.accountManagementChooseEmailText), data.statementDeliveryContacts.map(function (contactEmail) {
          return /*#__PURE__*/React.createElement("option", {
            value: contactEmail.deliveryContactNumber
          }, contactEmail.deliveryContactEmail);
        })))), _this4.state.statementEmailNotPicked && /*#__PURE__*/React.createElement("p", {
          className: "error-text-email"
        }, "*Required field")), editAccountInfo.statementDeliveryMethod !== 2 && /*#__PURE__*/React.createElement("td", {
          className: "second-span-edit second-table-row"
        }, /*#__PURE__*/React.createElement("span", null, "\xA0"))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
          className: "second-span-edit second-table-row"
        }, /*#__PURE__*/React.createElement("span", null, _this4.translations.accountManagementInvoiceDeliveryMethodText), /*#__PURE__*/React.createElement("span", {
          className: "second-span-edit"
        }, /*#__PURE__*/React.createElement("div", {
          className: "comm-select-div"
        }, /*#__PURE__*/React.createElement("select", {
          value: editAccountInfo.invoiceDeliveryMethod,
          className: "comm-select-method-inv",
          onChange: _this4.onSelectInvoiceChange
        }, /*#__PURE__*/React.createElement("option", {
          value: "0"
        }, _this4.translations.accountManagementMailOptionText), /*#__PURE__*/React.createElement("option", {
          value: "2"
        }, _this4.translations.accountManagementEmailOptionText), /*#__PURE__*/React.createElement("option", {
          value: "1"
        }, _this4.translations.accountManagementDoNotSendOptionText)))))), /*#__PURE__*/React.createElement("tr", null, editAccountInfo.invoiceDeliveryMethod === 2 && /*#__PURE__*/React.createElement("td", {
          className: "second-span-edit second-table-row"
        }, /*#__PURE__*/React.createElement("span", null, _this4.translations.accountManagementSelectEmailText), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
          className: "comm-select-div"
        }, /*#__PURE__*/React.createElement("select", {
          value: editAccountInfo.selectedInvoiceDeliveryContact,
          className: "comm-select",
          onChange: _this4.onSelectInvoiceEmail
        }, /*#__PURE__*/React.createElement("option", {
          hidden: true,
          disabled: true,
          value: ""
        }, _this4.translations.accountManagementChooseEmailText), data.invoiceDeliveryContacts.map(function (contactEmail) {
          return /*#__PURE__*/React.createElement("option", {
            value: contactEmail.deliveryContactNumber
          }, contactEmail.deliveryContactEmail);
        })))), _this4.state.invoiceEmailNotPicked && /*#__PURE__*/React.createElement("p", {
          className: "error-text-email"
        }, "*Required field")), editAccountInfo.invoiceDeliveryMethod !== 2 && /*#__PURE__*/React.createElement("td", {
          className: "second-span-edit second-table-row"
        }, /*#__PURE__*/React.createElement("span", null, "\xA0")))))), data.isEdit && /*#__PURE__*/React.createElement("p", {
          className: "submit-btn-edit"
        }, _this4.state.phoneNotValidate || _this4.state.phoneNotValidate || _this4.state.phoneNotComplete || _this4.state.emailNotValidate || _this4.state.emailNotComplete || _this4.state.statementEmailNotPicked || _this4.state.invoiceEmailNotPicked ? '' : /*#__PURE__*/React.createElement("p", {
          className: "error-msg-btn"
        }, "\xA0"), _this4.state.phoneNotValidate && /*#__PURE__*/React.createElement("p", {
          className: "error-msg-btn validate-msg"
        }, _this4.translations.accountManagementValidPhoneErrorText), _this4.state.phoneNotComplete && /*#__PURE__*/React.createElement("p", {
          className: "error-msg-btn req-msg"
        }, _this4.translations.accountManagementPhoneRequireErrorText), _this4.state.emailNotValidate && /*#__PURE__*/React.createElement("p", {
          className: "error-msg-btn validate-msg"
        }, _this4.translations.accountManagementValidEmailErrorText), _this4.state.emailNotComplete && /*#__PURE__*/React.createElement("p", {
          className: "error-msg-btn req-msg"
        }, _this4.translations.accountManagementEmailRequireErrorText), (_this4.state.statementEmailNotPicked || _this4.state.invoiceEmailNotPicked) && /*#__PURE__*/React.createElement("p", {
          className: "error-msg-btn email-msg"
        }, _this4.translations.accountManagementChooseEmailErrorText), /*#__PURE__*/React.createElement("a", {
          className: "cancel-tag",
          onClick: function onClick() {
            _this4.cancelEditAccordion(data);
          }
        }, "Cancel"), /*#__PURE__*/React.createElement("button", {
          className: "wdh-feature-b2b-button dark-bg submit-btn",
          onClick: function onClick(e) {
            _this4.saveEditAccountInfo(e);
          }
        }, "Submit")))));
      }), /*#__PURE__*/React.createElement(ModalDialog, {
        isOpen: this.state.accountSaveModal,
        className: "wdh-feature-btb-modalContent wdh-feature-btb-modalContent-account-mng-save-Modal",
        type: ModalDialog.types.blank,
        onCancelClick: function onCancelClick() {
          return _this4.closeAccountModal();
        },
        showCloseButton: true
      }, /*#__PURE__*/React.createElement("p", {
        className: "acct-mng-empty-p-modal"
      }, "\xA0"), /*#__PURE__*/React.createElement("p", {
        className: "acct-mng-desc-p-modal"
      }, this.translations.accountManagementModalText))));
    }
  }]);
}(React.Component);
export default AccountManagementAccordion;